import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Brand } from 'src/typings';
import { BrandService } from '../brand.service';

@Component({
  selector: 'app-multi-selector',
  templateUrl: './multi-selector.component.html',
  styleUrls: ['./multi-selector.component.scss']
})
export class MultiSelectorComponent {
  @Input() control: FormControl = new FormControl<Brand[]>([]);

  allBrands: Brand[] = [];

  constructor(private brandService: BrandService) {
    this.loadBrands();
  }

  async loadBrands() {
    this.allBrands = await firstValueFrom(this.brandService.getAllBrands());
  }
}
